import createAction from '../services/create-action';
import uri from 'urijs';

export const FETCH_COMMENT_REQUEST = 'comment/FETCH_REQUEST';
export const FETCH_COMMENT_SUCCESS = 'comment/FETCH_SUCCESS';
export const FETCH_COMMENT_FAILURE = 'comment/FETCH_FAILURE';

export const fetchCommentRequest = createAction(FETCH_COMMENT_REQUEST);
export const fetchCommentSuccess = createAction(FETCH_COMMENT_SUCCESS);
export const fetchCommentFailure = createAction(FETCH_COMMENT_FAILURE);

export const fetchComment = ({ postId, commentId }) => {
  return (dispatch, getState, { request }) => {
    dispatch(fetchCommentRequest({ postId }));

    const promise = request(uri(`/_api/posts/${postId}/comments/${commentId}`));
    return promise
      .then(comment => {
        return dispatch(fetchCommentSuccess({ comment, postId }));
      })
      .catch(() => dispatch(fetchCommentFailure({ postId })))
      .then(() => promise);
  };
};



// WEBPACK FOOTER //
// ./app/actions/fetch-comment.js